<div class="request-demo">
  <div class="request-demo__container">
    <!-- Left Section: White Background with Form -->
    <div class="request-demo__left">
      <div class="request-demo__left-content">
        <!-- Header -->
        <div class="request-demo__left-content-header">
          <a [routerLink]="APP_ROUTES.GUEST.ROOT" class="request-demo__left-content-header-logo">
            <img [src]="ASSETS.logo" alt="ICXBee Logo" class="request-demo__left-content-header-logo-image" />
          </a>
          <a [routerLink]="APP_ROUTES.GUEST.ROOT" class="request-demo__left-content-header-back-link">
            <span> Back to website </span> <i class="bi bi-arrow-right text-base"></i>
          </a>
        </div>

        <!-- Title and Subtitle -->
        <div class="request-demo__left-content-section">
          <div class="request-demo__left-content-section-container">
            <h1 class="request-demo__left-content-section-container-title">Book a Personalized Demo</h1>
            <p class="request-demo__left-content-section-container-subtitle">
              Give us your requirements, we shall contact you shortly.
            </p>
          </div>
          <div class="contact-form-section__wrapper">
            <form [formGroup]="demoForm" (ngSubmit)="onSubmit()" class="contact-form-section__wrapper-form">

              <div class="contact-form-section__wrapper-form__fields-row">
                <div class="contact-form-section__wrapper-form__fields-row__group">
                  <label class="contact-form-section__wrapper-form__fields-row__group-label">
                    First Name<span class="contact-form-section__wrapper-form__fields-row__group-required">*</span>
                  </label>
                  <input type="text" formControlName="name"
                    class="contact-form-section__wrapper-form__fields-row__group-input"
                    [class.contact-form-section__wrapper-form__fields-row__group-input--error]="getFieldError('name')" />
                  @if (getFieldError('name')) {
                  <span class="contact-form-section__wrapper-form__fields-row__group-error">{{ getFieldError('name')
                    }}</span>
                  }
                </div>


                <div class="contact-form-section__wrapper-form__fields-row__group">
                  <label class="contact-form-section__wrapper-form__fields-row__group-label"> Last Name </label>
                  <input type="text" formControlName="lastName"
                    class="contact-form-section__wrapper-form__fields-row__group-input" />
                </div>
              </div>

              <div class="contact-form-section__wrapper-form__fields-row">

                <div class="contact-form-section__wrapper-form__fields-row__group">
                  <label class="contact-form-section__wrapper-form__fields-row__group-label">
                    Business Email<span class="contact-form-section__wrapper-form__fields-row__group-required">*</span>
                  </label>
                  <input type="email" formControlName="email"
                    class="contact-form-section__wrapper-form__fields-row__group-input"
                    [class.contact-form-section__wrapper-form__fields-row__group-input--error]="getFieldError('email')" />
                  @if (getFieldError('email')) {
                  <span class="contact-form-section__wrapper-form__fields-row__group-error">{{ getFieldError('email')
                    }}</span>
                  }
                </div>

                <div class="contact-form-section__wrapper-form__fields-row__group">
                  <label class="contact-form-section__wrapper-form__fields-row__group-label">
                    Mobile Number<span class="contact-form-section__wrapper-form__fields-row__group-required">*</span>
                  </label>
                  <input type="tel" formControlName="phoneNumber"
                    class="contact-form-section__wrapper-form__fields-row__group-input"
                    (input)="onPhoneNumberInput($event)"
                    [class.contact-form-section__wrapper-form__fields-row__group-input--error]="getFieldError('phoneNumber')" />
                  @if (getFieldError('phoneNumber')) {
                  <span class="contact-form-section__wrapper-form__fields-row__group-error">{{
                    getFieldError('phoneNumber') }}</span>
                  }
                </div>
              </div>

              <div class="contact-form-section__wrapper-form__fields-row">

                <div class="contact-form-section__wrapper-form__fields-row__group">
                  <label class="contact-form-section__wrapper-form__fields-row__group-label">
                    Company<span class="contact-form-section__wrapper-form__fields-row__group-required">*</span>
                  </label>
                  <input type="text" formControlName="organizationName"
                    class="contact-form-section__wrapper-form__fields-row__group-input"
                    [class.contact-form-section__wrapper-form__fields-row__group-input--error]="getFieldError('organizationName')" />
                  @if (getFieldError('organizationName')) {
                  <span class="contact-form-section__wrapper-form__fields-row__group-error">{{
                    getFieldError('organizationName')
                    }}</span>
                  }
                </div>


                <div class="contact-form-section__wrapper-form__fields-row__group">
                  <label class="contact-form-section__wrapper-form__fields-row__group-label"> Team Size </label>
                  <select formControlName="teamSize"
                    class="contact-form-section__wrapper-form__fields-row__group-select">
                    @for (teamSize of teamSizes; track teamSize.value) {
                    <option [value]="teamSize.value">{{ teamSize.label }}</option>
                    }
                  </select>
                </div>
              </div>

              <div
                class="contact-form-section__wrapper-form__fields-row__group contact-form-section__wrapper-form__fields-row__group--full">
                <label class="contact-form-section__wrapper-form__fields-row__group-label">
                  Kindly mention your demo requirements
                </label>
                <textarea formControlName="message"
                  class="contact-form-section__wrapper-form__fields-row__group-textarea" rows="1"></textarea>
              </div>


              <div class="contact-form-section__wrapper-form__privacy">
                <p class="contact-form-section__wrapper-form__privacy-text">
                  By submitting this form, you agree to processing of personal data according to our
                  <a class="contact-form-section__wrapper-form__privacy-link " (click)="onClickLegalLink(legalLinks[0])"
                    target="_blank" rel="noopener noreferrer">privacy policy.</a>
                </p>
              </div>

        
              <div class="invisible">
                <app-captcha formControlName="recaptcha" [size]="'invisible'"></app-captcha>
              </div>

            </form>
          </div>
          <div>
            <app-button variant="primary" label="<span class='mx-3'>Submit</span>" [loading]="isLoading"
              [disabled]="isLoading" [fullWidth]="false" size="medium" (appClick)="onSubmit()" [width]="'116'">
            </app-button>
          </div>

        </div>

        <!-- Form -->


        <div class="request-demo__footer">
          <p class="request-demo__footer-text">
            © 2025 ICXBee by QUAPT Technologies. All rights reserved.
          </p>
        </div>
      </div>
    </div>

    <div class="request-demo__right">
      <div class="request-demo__right-content">
        <div class="request-demo__right-content-container">
          <!-- Main Title -->
          <div class="request-demo__right-content-container-card">
            <h2 class="request-demo__right-content-container-card-title">Discover the Power of ICXBee</h2>

            <!-- Description -->
            <p class="request-demo__right-content-container-card-description">
              Transform how your team grows, learns, and collaborates. Schedule a personalized demo
              to see how ICXBee can elevate your team's performance.
            </p>
          </div>

          <!-- Key Benefits -->
          <div class="request-demo__right-content-container-benefits">
            <h3 class="request-demo__right-content-container-benefits-title">Key Benefits:</h3>
            <ul class="request-demo__right-content-container-benefits-list">
              <li class="request-demo__right-content-container-benefits-item">
                Real-time insights: Get actionable feedback from your team, instantly.
              </li>
              <li class="request-demo__right-content-container-benefits-item">
                Comprehensive reports: Analyze performance trends and growth areas.
              </li>
              <li class="request-demo__right-content-container-benefits-item">
                Secure and private: All data is encrypted and safely stored.
              </li>
            </ul>
          </div>

          <!-- Additional Note -->
          <div class="request-demo__right-content-container-note">
            <h3 class="request-demo__right-content-container-note-title">Additional Note:</h3>
            <p class="request-demo__right-content-container-note-text">
              Our demo is customized to fit your needs. Share your details, and we'll tailor the
              experience to your goals.
            </p>
          </div>

          <!-- Trusted By Section -->
          <!-- <div class="request-demo__trusted">
          <h3 class="request-demo__trusted-title">Trusted By:</h3>
          <div class="request-demo__trusted-logos">
            <div class="request-demo__trusted-logo">
              <img [src]="ASSETS.IMAGES.HOME.TRUST.ADOBE" alt="Adobe" class="request-demo__trusted-logo-image " />
            </div>
            <img [src]="ASSETS.IMAGES.HOME.TRUST.SPOTIFY" alt="Spotify" class="request-demo__trusted-logo-image" />
            <img [src]="ASSETS.IMAGES.HOME.TRUST.GRAMMarly" alt="Grammarly" class="request-demo__trusted-logo-image" />
            <img [src]="ASSETS.IMAGES.HOME.TRUST.TINDER" alt="Tinder" class="request-demo__trusted-logo-image" />
          </div>
        </div> -->
        </div>


        <div class="request-demo__right-content-footer">
          <div class="request-demo__right-content-footer-links">
            @for (link of legalLinks; track link.label; let last = $last) {
            <a (click)="onClickLegalLink(link)" class="request-demo__right-content-footer-link">{{
              link.label
              }}</a>
            @if (!last) {
            <span class="request-demo__right-content-footer-separator"></span>
            } }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>